// This file is auto-generated by dibs-icons script
import { FC } from 'react';
import CheckCircle20 from './CheckCircle20';
import CheckCircle20Filled from './CheckCircle20Filled';
import CheckCircle24 from './CheckCircle24';
import CheckCircle24Filled from './CheckCircle24Filled';
import CheckCircle40 from './CheckCircle40';
import CheckCircle40Filled from './CheckCircle40Filled';
import CheckCircle48 from './CheckCircle48';
import CheckCircle48Filled from './CheckCircle48Filled';

type CheckCircleProps = {
    variation: '20' | '20Filled' | '24' | '24Filled' | '40' | '40Filled' | '48' | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    CheckCircle20,
    CheckCircle20Filled,
    CheckCircle24,
    CheckCircle24Filled,
    CheckCircle40,
    CheckCircle40Filled,
    CheckCircle48,
    CheckCircle48Filled,
};

const CheckCircle: FC<CheckCircleProps> = ({ variation, ...props }) => {
    const variationKey = `CheckCircle${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"CheckCircle" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default CheckCircle;
